import { ref } from 'vue';

const scrollPosition = ref(0);

export function useBodyScroll() {
  function lockScroll() {
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.body.style.overflow = 'auto';
  }

  function registerScrollHandler() {
    window.addEventListener('scroll', () => {
      scrollPosition.value = window.scrollY;
    });
  }

  function unregisterScrollHandler() {
    window.removeEventListener('scroll', () => {});
  }

  return {
    registerScrollHandler,
    unregisterScrollHandler,
    lockScroll,
    unlockScroll,
    scrollPosition
  };
}
